import React from "react";
import { ChevronRight } from "lucide-react";
import { useAlertsOverview } from "@/hooks/useCryptoAlerts";

interface AiInsightCardProps {
  onClick: () => void;
  title?: string;
  text?: string;
}

/** "AI Market Insight" banner from the redesign; opens the Analyze page. */
export const AiInsightCard: React.FC<AiInsightCardProps> = ({
  onClick,
  title = "AI Market Insight",
  text,
}) => {
  const { data: overview } = useAlertsOverview();
  const body =
    text ??
    (overview
      ? `${overview.listings.count} new listings this week, ${overview.hot.count} ran ${overview.hot.thresholdPercent}%+ after their alert. Get an AI read before you trade.`
      : "Get an AI read on any token before you trade it.");
  return (
    <button
      type="button"
      onClick={onClick}
      className="relative flex w-full items-center gap-2 overflow-hidden rounded-xl border border-[rgba(45,204,137,0.24)] bg-primary p-3 text-left"
    >
      <img
        src="/ai-insight.jpg"
        alt=""
        className="pointer-events-none absolute inset-0 size-full object-cover opacity-20"
      />
      <img src="/icons/brain-ai.svg" alt="" width={48} height={48} className="relative shrink-0" />
      <span className="relative flex min-w-0 flex-1 flex-col gap-1">
        <span className="text-sm font-semibold leading-5 text-white">{title}</span>
        <span className="text-[10px] leading-3 text-[#d4d4d4]">{body}</span>
      </span>
      <ChevronRight className="relative size-5 shrink-0 text-white" />
    </button>
  );
};
